import { Component, inject, OnInit } from '@angular/core';
import { CurrentDataService } from '../../../services/current-data-service';
import { PATHS } from '../../../models/bary-paths.model';
import { BasketOrder } from '../../../models/basket-order.model';
import { BasketOrderService } from '../../../services/basket-order.service';
import { CustomerService } from '../../../services/customer.service';
import { TransportOrderExtendedService } from '../../../services/transport-order-extended.service';

import { BasketOrderExtendedService } from '../../../services/basket-order-extended.service';
import { combineLatest } from 'rxjs';
import { StatsButton } from '../../../models/stats-button';
import { ICustomer } from '../../../models/customer.model';
import { UserTypology } from '../../../models/enums/user-typology.model';
import { BaryModalService } from '../../../services/bary-modal.service';
import { StatsUnit } from '../../../models/enums/stats-unit.enum';
import { BillService } from '../../../services/bill-service';
import { TransportOrderView } from '../../../models/transport-order-view.model';
import { TransporterEnum } from '../../../models/enums/transporter-enum.enum';

@Component({
  selector: 'jhi-my-dashboard',
  templateUrl: './my-dashboard.component.html',
  styleUrls: ['./my-dashboard.component.scss'],
})
export class MyDashboardComponent implements OnInit {
  readonly #currentDataService = inject(CurrentDataService);
  readonly #transportOrderExtendedService = inject(TransportOrderExtendedService);
  readonly #basketOrderService = inject(BasketOrderService);
  readonly #customerService = inject(CustomerService);
  readonly #basketOrderExtendedService = inject(BasketOrderExtendedService);
  readonly #baryModalService = inject(BaryModalService);
  readonly #billService = inject(BillService);

  public buttons: StatsButton[] = [];
  public customer: ICustomer | undefined;
  public customerId: number | undefined;
  public transportOrders: Array<TransportOrderView> = [];
  public bills: Array<BasketOrder> = [];
  public hasIncompleteData = false;
  public isGoevia = false;
  public isAbo = false;
  public PATHS = PATHS;
  public userTypology = UserTypology;

  constructor() {
    this.initializeButtons();
  }

  ngOnInit(): void {
    combineLatest([this.#currentDataService.getCurrentTransporter(), this.#currentDataService.getCustomer(), this.#customerService.hasIncompleteData()]).subscribe({
      next: (data: any) => {
        this.isGoevia = data[0]?.technicalName === TransporterEnum.GOEVIA.technicalName;
        this.isAbo = data[0]?.technicalName === TransporterEnum.ABO.technicalName;
        if (data[1]) {
          this.customer = data[1];
          this.customerId = data[1].id;
          this.loadTransportOrder();
          this.loadBills();
          this.#basketOrderExtendedService.findBillsNoPaid(this.customerId!).subscribe(it => {
            if (it.length > 0) {
              this.#baryModalService.openUserNotificationDifferedPayment(UserTypology.INIT_TRANSFERT_DEFERRED, this.customer, it).action().subscribe();
            }
          });
        }
        this.hasIncompleteData = data[2] ?? false;
      },
    });
  }

  private initializeButtons(): void {
    this.buttons.push(new StatsButton('turnoverBilled', 'CA', 'baryApp.customer-statistics.charts.turnoverBilled.user.title', 0, StatsUnit.EURO, 2));
    this.buttons.push(new StatsButton('transport', 'TR', 'baryApp.customer-statistics.charts.transport.title', 0, undefined, 0));
    this.buttons.push(new StatsButton('pallets', 'PA', 'baryApp.customer-statistics.charts.pallets.title', 0, undefined, 0));
    this.buttons.push(new StatsButton('carbonfootprint', 'CAR', 'baryApp.customer-statistics.charts.carbonfootprint.title', 0, StatsUnit.KILOGRAM, 2));
  }

  private loadTransportOrder(): void {
    this.#transportOrderExtendedService
      .query({
        'customerId.equals': this.customerId,
        page: 0,
        size: 2,
        sort: ['pickupDate,desc'],
      })
      .subscribe(httpResponse => (this.transportOrders = httpResponse.body as TransportOrderView[]));
  }

  private loadBills(): void {
    this.#basketOrderService
      .query({
        'customerId.equals': this.customerId,
        page: 0,
        size: 2,
        sort: ['billDate,desc'],
      })
      .subscribe(bill => {
        if (bill?.body) {
          this.bills = bill.body;
        }
      });
  }

  public browserPdf(id: number): void {
    this.#billService.browserPdf(id);
  }

  public download(id: number): void {
    this.#billService.download(id);
  }
}
